import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface IProps {
  isCartPage: boolean;
  hasDevice: boolean;
  hasPlan: boolean;
  closePopUp?: () => void;
  removeNotification?: () => void;
}

const CartNotification: React.FC<IProps> = ({
  hasPlan,
  isCartPage,
}) => {
  const message = !hasPlan
    ? "To use this device, an active subscription is needed. You’ll select your preferred plan during the activation process."
    : "To fully utilize your subscription a compatible tracker is required for seamless integration and functionality.";


  return (
    <Box
      display="flex"
      gap={{ xs: 1, md: 2 }}
      flexDirection={{ xs: "column", md: "row" }}
      pb={{ xs: 4, md: 5.75 }}
    >
      <Box
        p={2}
        border="1px solid #DD0000"
        borderRadius={2}
        display="flex"
        justifyContent="start"
        alignItems="center"
        gap={1}
        mb={!isCartPage ? 2.25 : 0}
        maxWidth={{ xs: "auto", md: 580 }}
      >
        <ErrorOutlineIcon fontSize="small" sx={{ fill: "#DD0000" }} />
        <Typography variant="body2" fontWeight={600} fontSize={"1rem"}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default CartNotification;
